module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAEBGQTXAAAABGdBTUEAALGPC/xhBQAAASRJREFUKBWNkrtKA1EQho8mhVcQBLHRRhsLL5WlYqeFD5EXEBtBjKQxgq34DPaCgr6BrVYp0qS0EQKChRfi9212glkV88O3czkzZ3fOnpS6mtKc+hiCLDLo6QSv1IuKTrGnbSJkW3U4IuwnfC9IW7FYxRn7gwO3GIFXWIYPeIcVMDcae+4SqA5U4AIm4CYKfo6XUtvta/D2C/UyyRb4HuVMjqFaMdskga9YB3NOkuyUFwN03zXZTmWrl2AxT25gPelNaOa5PrMfkZ1zcA4eyqBygD2b69CASxhUFQrnncyTjduwin8NDjkLdzAN43ALC6Cs71ik3EA9QvyuJ/xtk7l2wsFm9X62J+OnP0BRzyTOwEtxBDOg1uAw8/55HLN+BV6WPn0BLLYxEJy+eEEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/msg.png
// module id = QqtN
// module chunks = 1